import { render } from "./IconPadLock.vue?vue&type=template&id=f46b6834"
import script from "./IconPadLock.vue?vue&type=script&lang=js"
export * from "./IconPadLock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__